import { FONT_FAMILY } from '@utils/constants';
import humanizeUtil from '@utils/humanizeUtil';
import { axisFormatter } from './format';
import { formatter } from '@store/trends/birdChart/selectors';

const tooltipFormatter =
  ({ distributionConfig, intervalString }) =>
  (params) => {
    const { xAxisUnit, yAxisUnit, xAxisLabel, yAxisLabel } = distributionConfig;

    if (params && params.length) {
      const rec = params[0];
      const { data, color } = rec;

      const marker = `<span style="
      display: inline-block;
      background-color: ${color};
      width: 7px;
      height: 14px;
      position: relative;
      top: 2px;
      "></span>`;

      let displayValue = '0';
      if (data[1] !== null) {
        const { humanizedNumber, humanizedUnit } = humanizeUtil(data[1], yAxisLabel, yAxisUnit);
        displayValue = `${humanizedNumber} ${humanizedUnit}`;
      }
      const value = `<span style="
      margin-right: 10px;
      ">${displayValue}</span>`;

      const xVal = axisFormatter(data[0], xAxisUnit);
      return `
      <strong>${intervalString}</strong>
      <br/> ${xAxisLabel} ${xVal}
      <br/> ${marker} ${yAxisLabel} ${value}`;
    }

    return '-';
  };

const axisLabelColor = '#000';
const axisColor = '#ccc';

export const getDistributionOption = ({
  data,
  chartMetric,
  filterColor,
  distributionConfig,
  interval,
}) => {
  const { metric, xAxisUnit, yAxisUnit } = distributionConfig;

  const intervalString = `${formatter(interval.from)} - ${formatter(interval.to)}`;

  return {
    id: metric,
    _chartMetric: chartMetric,
    _metric: metric,
    _viewType: 'distribution',
    _distributionConfig: distributionConfig,
    animation: true,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: tooltipFormatter({ distributionConfig, intervalString }),
      confine: true,
      textStyle: { fontFamily: FONT_FAMILY, fontSize: 12 },
      appendToBody: true,
      className: 'echarts-tooltip',
    },
    grid: {
      top: 10,
      bottom: 35,
      left: 50,
      right: 35,
    },
    dataZoom: {
      // start: 0,
      type: 'slider',
      show: false,
    },
    brush: {
      brushType: 'lineX',
      seriesIndex: [0],
      brushLink: [0],
      xAxisIndex: [0],
      transformable: false,
      throttleType: 'debounce',
      throttleDelay: 300,
      brushStyle: {
        borderWidth: 1,
        color: 'rgba(120,140,180,0.3)',
        borderColor: 'rgb(224, 224, 224,0.8)',
      },
    },
    yAxis: {
      type: 'value',
      splitNumber: 2,
      axisLabel: {
        color: axisLabelColor,
        fontSize: 12,
        fontFamily: FONT_FAMILY,
        formatter: (value) => axisFormatter(value, yAxisUnit),
      },
      splitLine: {
        show: true,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: axisColor,
        },
      },
    },
    xAxis: {
      type: 'category',
      axisLabel: {
        color: axisLabelColor,
        fontSize: 12,
        fontFamily: FONT_FAMILY,
        hideOverlap: true,
        formatter: (value) => axisFormatter(value, xAxisUnit),
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        alignWithLabel: true,
        lineStyle: {
          color: axisColor,
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: axisColor,
        },
      },
    },
    series: [
      {
        type: 'bar',
        data,
        triggerLineEvent: true,
        showBackground: true,
        itemStyle: {
          color: filterColor,
        },
        markArea: {},
      },
    ],
    toolbox: {
      show: false,
    },
  };
};
